import get from 'lodash/get';
import * as actionTypes from '../actionTypes';
import getCountryIsoCodeFromLocationPath from '../utils/getCountryIsoCodeFromLocationPath';
import validateCountryIsoCode from '../utils/validateCountryIsoCode';
import { getCountryIsoCode, getCountrySpecificPath } from '../web/routes/Constants';

const getGlobalInfo = payload => dispatch => {
  const { countryIsoCode, checkCountrySpecificPath } = payload;
  let userUrlCountry = undefined;
  if (countryIsoCode) {
    userUrlCountry = countryIsoCode;
  } else if (checkCountrySpecificPath) {
    userUrlCountry = getCountryIsoCodeFromLocationPath(get(window, 'location.pathname', ''));
  } else if (getCountrySpecificPath()) {
    userUrlCountry = getCountryIsoCode();
  }
  dispatch({
    hmsFetchConfig: {
      path: `/hms_ms/api/v1/global_info`,
      headers: {
        'user_url_country': validateCountryIsoCode(userUrlCountry) ? userUrlCountry.toUpperCase() : undefined
      },
      method: 'GET'
    },
    onSuccess: ({ data, store }) => {
      store.dispatch({
        type: actionTypes.GET_GLOBAL_INFO,
        globaInfo: data
      });
    },
    onError: ({ error, store }) => {
      // Don't do anything
    }
  });
};
export default getGlobalInfo;